const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 4 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>path ' + (props.className || '')}
    >
      <path
        d="M1.60047 0C1.17625 0 0.7694 0.168567 0.46943 0.468619C0.16946 0.76867 0.000937889 1.17563 0.000937889 1.59996V9.59978C0.000937889 10.0241 0.16946 10.4311 0.46943 10.7311C0.7694 11.0312 1.17625 11.1997 1.60047 11.1997C2.02469 11.1997 2.43154 11.0312 2.73151 10.7311C3.03148 10.4311 3.2 10.0241 3.2 9.59978V1.59996C3.2 1.17563 3.03148 0.76867 2.73151 0.468619C2.43154 0.168567 2.02469 0 1.60047 0ZM2.73614 13.2957L2.49621 13.0877L2.20829 12.9437L1.90438 12.7997C1.6461 12.7503 1.37961 12.7653 1.12851 12.8434C0.877416 12.9215 0.649451 13.0604 0.464802 13.2477C0.320923 13.3951 0.206866 13.569 0.1289 13.7597C0.036722 13.96 -0.00710955 14.1793 0.000937889 14.3997C0.00270477 14.8194 0.169298 15.2216 0.464802 15.5196C0.619827 15.6657 0.798253 15.7847 0.992647 15.8716C1.18411 15.9563 1.39114 16 1.60047 16C1.8098 16 2.01683 15.9563 2.20829 15.8716C2.40269 15.7847 2.58111 15.6657 2.73614 15.5196C3.03164 15.2216 3.19823 14.8194 3.2 14.3997C3.19959 14.1852 3.15607 13.973 3.07204 13.7757C2.99056 13.5964 2.87669 13.4336 2.73614 13.2957Z"
      />
    </svg>
  );
};
